import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import BackgroundImage from "../../Assets/images/bg_v2.png";
import Logo from "../../Assets/images/logov2.png"; // Add your logo here

const Leftsection = () => {
    useEffect(() => {
        // Apply background image to body when component mounts
        document.body.style.backgroundImage = `linear-gradient(to right, transparent 50%, #ecf0fa 50%), url(${BackgroundImage})`;
        document.body.style.backgroundSize = '100% 100%, cover';
        document.body.style.backgroundPosition = 'center, center';
        document.body.style.backgroundRepeat = 'no-repeat, no-repeat';
        document.body.style.backgroundAttachment = 'fixed, fixed'; // Optional: keeps background fixed during scroll
        
        // Cleanup function to remove background when component unmounts
        return () => {
            document.body.style.backgroundImage = '';
            document.body.style.backgroundSize = '';
            document.body.style.backgroundPosition = '';
            document.body.style.backgroundRepeat = '';
            document.body.style.backgroundAttachment = '';
        };
    }, []);

    return (
        <div className="h-screen">
            <div className="container-fluid h-screen">
                <div className="row h-screen">
                    <div className="col-md-6 d-flex flex-column justify-content-between">
                        <div className="w-4/4 h-full hidden lg:flex justify-center items-center bg-cover bg-center">
                            {/* Highlight Box */}
                            <div className="bg-white bg-opacity-80 rounded-2xl p-12 text-center w-[600px] shadow-2xl">
                                <img src={Logo} alt="Logo" className="w-64 mx-auto mb-8" />
                                <p
                                    className="text-3xl font-semibold my-6"
                                    style={{ color: "#b93183" }}
                                >
                                    Join Campus Crow
                                </p>
                                <p className="text-gray-800 text-xl font-normal leading-relaxed">
                                    The ultimate online marketplace designed exclusively for university communities! Buy, sell, and connect securely with fellow students while accessing great deals on electronics, clothing, study materials, and more.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 " style={{background: '#ecf0fa'}}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Leftsection;